import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class StatisticsV2Service {

  private apiUrl = environment.apiBaseUrl + '/api/statistics-v2';

  constructor(private http: HttpClient) { }

  getAll(langCode: string = ''): Observable<any> {
    if (langCode === '') {
      return this.http.get(this.apiUrl);
    }

    return this.http.get(`${this.apiUrl}?lang=${langCode}`);
  }

  getById(id: number, langCode: string = ''): Observable<any> {
    if (langCode === '') {
      return this.http.get(`${this.apiUrl}/${id}`);
    }

    return this.http.get(`${this.apiUrl}/${id}?lang=${langCode}`);
  }

  create(request: any): Observable<any> {
    const formData = this.toFormData(request);

    return this.http.post(this.apiUrl, formData);
  }

  update(id: number, request: any): Observable<any> {
    const formData = this.toFormData(request);

    return this.http.put(`${this.apiUrl}/${id}`, formData);
  }

  delete(id: number): Observable<any> {
    return this.http.delete(`${this.apiUrl}/${id}`);
  }

  private toFormData(request: any): FormData {
    const formData = new FormData();

    if (request.file) {
      formData.append('File', request.file);
    }

    formData.append('Data', JSON.stringify(request.data));

    return formData;
  }
}
